import React from 'react';
import { useSelector } from 'react-redux';
import { InputNumber, Input, Col } from 'antd';
import RestSelect from 'components/RestInput/RestSelect';
import RestEditor from 'components/RestInput/RestEditor';
import RestDateTimePicker from 'components/RestInput/RestDateTimePicker';
import ReferenceInput from 'containers/rest/ReferenceInput';
import { inputNumberFormatter } from 'utils/textUtils';
import RestAvatarInput from 'components/RestInput/RestAvatarInput';
import RestInputItem from 'components/RestInput/RestInputItem';
import FormStyles from './styles';

const UsersForm = ({ isEdit, ...props }) => {
  const orderRequirements = useSelector(
    (state) => state.config?.data?.orderRequirement,
  );
  const platform = useSelector((state) => state.config?.data?.platform);
  const orderFeatures = useSelector(
    (state) => state.config?.data?.orderFeature,
  );
  const productCatalogs = useSelector(
    (state) => state.config?.data?.productType,
  );

  return (
    <FormStyles gutter={16} {...props}>
      <Col span={24}>
        <RestAvatarInput
          style={{ width: 250, height: 150, borderRadius: 0 }}
          defaultIcon="picture"
          defaultText="picture"
          hasCrop={false}
          source="thumbnail"
          label="Thumbnail"
        />
        <RestInputItem required source="name" header="orders.name" />
        <RestSelect
          required
          source="productCatalogIds"
          header="orders.productCatalogIds"
          titleProp="name"
          valueProp="id"
          resourceData={productCatalogs}
          mode="multiple"
          ruleType="array"
        />
      </Col>
      {/* <RestSelect required={!isEdit} allowClear={!isEdit} source="status" header="orders.status" titleProp="text" valueProp="value" resourceData={statuses} /> */}
      <Col span={12}>
        <RestSelect
          required={!isEdit}
          allowClear={!isEdit}
          source="orderRequirementId"
          header="orders.orderRequirementId"
          titleProp="name"
          valueProp="id"
          resourceData={orderRequirements}
          ruleType="number"
        />
      </Col>
      <Col span={12}>
        <RestInputItem
          required
          source="priceOrder"
          header="orders.priceOrder"
          ContentComponent={InputNumber}
          ruleType="number"
          min={0}
          step={10000}
          {...inputNumberFormatter()}
        />
      </Col>
      <Col span={12}>
        <RestSelect
          source="orderFeature"
          header="orders.orderFeature"
          titleProp="text"
          valueProp="value"
          resourceData={orderFeatures}
          mode="multiple"
          ruleType="array"
        />
      </Col>
      <Col span={12}>
        <RestSelect
          required
          source="platform"
          header="orders.platform"
          titleProp="name"
          valueProp="id"
          resourceData={platform}
        />
      </Col>
      <Col span={12}>
        <ReferenceInput
          required
          source="niche"
          searchKey="name"
          resource="niches"
          hasAdd
        >
          <RestSelect
            required
            header="orders.niche"
            titleProp="name"
            valueProp="id"
            isFilterOption={false}
          />
        </ReferenceInput>
      </Col>
      <Col span={12}>
        <RestDateTimePicker
          isShowTime
          source="deadline"
          header="orders.deadline"
        />
      </Col>
      <Col span={24}>
        <RestEditor
          source="customerRequirements"
          header="orders.customerRequirements"
          ContentComponent={Input.TextArea}
          defaultValue={`
<b>Template/ size:</b><br/><br/>
<b>Yêu cầu</b>:<br/><br/>
<b>Note</b>:<br/><br/>
`}
        />
      </Col>
    </FormStyles>
  );
};

UsersForm.propTypes = {};

export default UsersForm;
